import { render } from "./install-app.vue?vue&type=template&id=7c67319a&ts=true"
import script from "./install-app.vue?vue&type=script&lang=ts"
export * from "./install-app.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Jawdat\\Projects\\public_html\\linfolio\\node_modules\\.pnpm\\vue-loader@17.0.0_webpack@5.70.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__